<template>
  <div
    class="grande-div flex items-center justify-between bg-white px-4 md:px-10 py-4 md:py-3"
  >
    <div class="flex items-center" @click="goto()">
      <img
        src="../../assets/img/logo.png"
        alt=""
        class="cursor-pointer rounded-c5 h-10 md:h-16"
      />
      <div class="ml-1 md:ml-4 font-bold md:text-c18 text-c10">
        Panneau Mobile
      </div>
    </div>
    <div class="text-c14 md:text-c32 font-bold">
      {{ donnes ? donnes.company : "" }}
    </div>
  </div>
</template>

<script>
// prettier-ignore

export default {
  name: "TheHeader",
  components: {
  },
  props: {
    donnes: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
    };
  },

  methods: {
    goto () {
      window.open('https://panneaumobile.co', '_blank')
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/sass/variables";
//@import "../../assets/style/sass/mixin";

.grande-div {
  //position: fixed;
  width: 100%;
  z-index: 8;
  background-color: white;
}
</style>
